import React from 'react'
// import { Box } from '@mui/system'
import { connect } from 'react-redux'
import DropDownOA from '../../../../common/dropDownOA'
import { Item } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import * as lb from '../../../Reports/reportLables'
import * as id from '../../../Reports/reportId'
import { Box, Button } from '@mui/material'
import ConsignmentTable from './ConsignmentTable'
import ConsignmentTypeModal from './ConsignmentTypeModal'
import { getMethodOfPacking, updateAlertError, updateModal } from '../../../../../store/common/common_action'
import { useEffect } from 'react'
import { focusElemnt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../../../common/helper'
import { useState } from 'react'
import { getBookingConsType, bookingConsTypeTableData } from '../../../../../store/generalSetting/GSAction'
import { useTranslation } from '../../../../../i18n/I18nProvider'

const ConsignmentType = (props) => {
  const { data, updateModal, getBookingConsType, updateAlertError, bookingConsTypeTableData, getMethodOfPacking } = props
  const { common, generalSettingReducer } = data
  const { showModal, modalType, loginData } = { ...common }
  const { bookingConsType } = generalSettingReducer
  const { translations, language } = useTranslation()
  const gs = translations?.generalSettings || {}
  const tr = (key, fallback) => gs?.[key] || fallback
  const newConsignment = { id: 'CreateNewConsignmentType', lrListLabel: 'Create New Consignment Type popup modal', isSaved: false }
  const statusOpt = [
    { name: tr('gsActive', 'Active'), id: 1 },
    { name: tr('inActive', 'InActive'), id: 0 },
  ]

  const [selStatus, setSelStatus] = useState(statusOpt?.[0])
  const [consTypeOpt, setConsTypeOpt] = useState([])
  const [selConsType, setSelConsType] = useState('')
  const [tableData, setTableData] = useState([])
  const propData = {
    selConsType: selConsType,
    selStatus: selStatus,
  }
  useEffect(() => {
    if (!isEmpty(loginData)) {
      if (bookingConsType?.length === 0) {
        const obj = {
          intConsignmentSubTypeID: 0,
          intCompanyID: loginData?.intCompanyID,
          intConsignmentTypeID: 0,
          strSubType: '',
          intIsActive: 1,
          intIsDeleted: 0,
        }
        getBookingConsType(obj)
      }
      getMethodOfPacking(loginData)
    }
  }, [loginData])
  useEffect(() => {
    if (bookingConsType?.length > 0) {
      const data = [{ SubType: tr('gsAll', 'All'), ConsignmentSubTypeID: 0 }, ...bookingConsType]
      const options = removeDuplicatesFromArray(
        data.map((val) => ({ ...val, SubType: val.SubType.trim() })),
        'SubType'
      )
      setConsTypeOpt(options)
      setTableData(bookingConsType)
      setSelConsType((prev) => prev || options[0])
    } else {
      setConsTypeOpt([])
      setTableData([])
      setSelConsType('')
    }
  }, [bookingConsType])
  useEffect(() => {
    const allLabel = tr('gsAll', 'All')
    setConsTypeOpt((prev) =>
      prev.map((item) => item.ConsignmentSubTypeID === 0 ? { ...item, SubType: allLabel } : item)
    )
    setSelConsType((prev) =>
      prev?.ConsignmentSubTypeID === 0 ? { ...prev, SubType: allLabel } : prev
    )
  }, [translations])
  useEffect(() => {
    setSelStatus((prev) => statusOpt.find((item) => item.id === prev?.id) || statusOpt[0])
  }, [translations])
  useEffect(() => {
    focusElemnt('GSBConsignment_Type')
  }, [])

  const ConsTypeModal = () => {
    return <ConsignmentTypeModal isUpdate={false} propData={propData} />
  }

  const handleSearch = () => {
    if (selConsType === '') {
      updateAlertError({ show: true, msg: tr('gsSelCnsType', 'Select Consignment Type'), nextId: 'GSBConsignment_Type' })
    } else {
      const obj = {
        intConsignmentSubTypeID: selConsType?.ConsignmentSubTypeID,
        intCompanyID: loginData?.intCompanyID,
        intConsignmentTypeID: 0,
        strSubType: selConsType?.ConsignmentSubTypeID === 0 ? '' : selConsType?.SubType || '',
        intIsActive: selStatus?.id,
        intIsDeleted: 0,
      }
      bookingConsTypeTableData(obj)
        .then((res) => {
          if (res?.status == 'Success') {
            if (res.Data.length > 0) {
              setTableData(res.Data)
            } else {
              updateAlertError({ show: true, msg: tr('noDataFound', 'No Data Found'), nextId: '' })
              setTableData([])
            }
          } else {
            updateAlertError({ show: true, msg: res.ErrMessage, nextId: 'GSBConsignment_Type' })
            setTableData([])
          }
        })
        .catch((err) => {
          console.log('Error:', err)
        })
    }
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        <Box sx={sx.reportFlex} className="itemButtons" style={{ paddingLeft: '0px', paddingRight: '0px' }}>
          <Item sx={sx.itemsx} style={{ width: '250px' }}>
            <DropDownOA
              key={`GSBConsignment_Type-${language}-${selConsType?.SubType}`}
              id={'GSBConsignment_Type'}
              label={tr('gsSelCnsType', 'Select Consignment Type')}
              searchPlaceholder={tr('searchConsignmentType', 'Search Consignment Type')}
              defaultvalue={selConsType?.SubType || selConsType}
              value={selConsType?.SubType || selConsType}
              data={consTypeOpt || []}
              listWidth="230px"
              width="100%"
              dataKey={`SubType`}
              idKey={`ConsignmentSubTypeID`}
              onSelect={(obj) => setSelConsType(obj)}
              nextId={'GSBStatus'}
              prevId={'CreateNC'}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ width: '250px' }}>
            <DropDownOA
              key={`GSBStatus-${language}-${selStatus?.name}`}
              id={'GSBStatus'}
              label={tr('selectsStatus', 'Selects Status')}
              searchPlaceholder={tr('searchSelectedStatus', 'Search Selected Status')}
              defaultvalue={selStatus?.name}
              data={statusOpt || []}
              listWidth="230px"
              width="100%"
              dataKey={`name`}
              idKey={`id`}
              onSelect={(obj) => setSelStatus(obj)}
              nextId={'SearchBtn'}
              prevId={'GSBConsignment_Type'}
            />
          </Item>
          <Item
            sx={sx.itemsx}
            className="disabled-wrapper"
            onKeyDown={(e) => navigation3(e, 'CreateNC', 'GSBStatus', () => handleSearch())}
          >
            <Button
              id="SearchBtn"
              variant="contained"
              style={{ ...sx.fullHeight, ...sx.novp }}
              className="btn btn-primary"
              onClick={() => handleSearch()}
            >
              {tr('search', 'Search')}
            </Button>
          </Item>
          <Item
            sx={{ ...sx.itemsx }}
            className="disabled-wrapper"
            onKeyDown={(e) => navigation3(e, 'GSBConsignment_Type', 'SearchBtn', () => updateModal(true, 'CreateNewConsignmentType'))}
          >
            <Button
              id="CreateNC"
              variant="outlined"
              sx={{ width: '100%' }}
              className="receiveitembtn"
              onClick={() => updateModal(true, 'CreateNewConsignmentType')}
            >
              {tr('createNewConsignment', '+ CREATE NEW CONSIGNMENT')}
            </Button>
          </Item>
        </Box>
        <Box sx={{ marginTop: '15px' }}>
          <ConsignmentTable tableData={tableData} propData={propData} />
        </Box>
      </Item>
      {/* {showModal && newConsignment.id === modalType ? ConsTypeModal() : null} */}
      {showModal && [newConsignment.id].includes(modalType) && ConsTypeModal(newConsignment.id)}
    </>
  )
}

const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
  updateModal,
  getBookingConsType,
  updateAlertError,
  bookingConsTypeTableData,
  getMethodOfPacking,
}

export default connect(mapStateToProps, mapDispatchToProps)(ConsignmentType)
